import { render, staticRenderFns } from "./subscription.vue?vue&type=template&id=90dd0a00&"
import script from "./subscription.vue?vue&type=script&lang=ts&"
export * from "./subscription.vue?vue&type=script&lang=ts&"
import style0 from "./subscription.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./subscription.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports